module.exports = __webpack_public_path__ + "static/logo-906e796d0d81178057e11fc8df4857ae.png";